export default "__VITE_ASSET__Le38qInO__"